import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  getBanner() {
    const response = Api().post(apiPath.banner);
    return response;
  },

  getDesign() {
    const response = Api().post(apiPath.design);
    return response;
  },

  getNewsTitles() {
    const response = Api().post(apiPath.newsTitles);
    return response;
  },

  createInquiry(options, data) {
    const response = Api().post(apiPath.inquiry_create, data, options);
    return response;
  }
};
